import React, { useRef, useEffect } from 'react'
import { memo } from 'react'
import { Modal, Box, IconButton, Typography, Slide } from '@mui/material'
import { Close as CloseIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material'
import JobDetailContent from './JobDetailContent'

const JobModal = memo(({ job, rankedJob, onClose, conversationId, onFavoriteClick, isMobile }) => {
  const modalContentRef = useRef(null)

  useEffect(() => {
    if (job && modalContentRef.current) {
      modalContentRef.current.scrollTop = 0
    }
  }, [job])

  if (!job) return null

  return (
    <Modal
      open={!!job}
      onClose={onClose}
      closeAfterTransition
      aria-labelledby="job-details-modal"
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'center',
        p: { xs: 0, md: 2 },
        pt: { xs: 0, md: 2 },
        overflow: 'auto'
      }}
    >
      <Slide direction="left" in={!!job} mountOnEnter unmountOnExit timeout={250}>
        <Box
          ref={modalContentRef}
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 900,
            height: { xs: '100vh', md: 'auto' },
            maxHeight: { xs: '100vh', md: '90vh' },
            bgcolor: 'background.paper',
            borderRadius: { xs: 0, md: 2 },
            boxShadow: 24,
            p: { xs: 2, md: 4 },
            pt: { xs: 0, md: 4 },
            overflow: 'auto',
            paddingBottom: { xs: 'env(safe-area-inset-bottom)', md: 4 },
          }}
        >
          {/* Mobile: sticky back arrow header */}
          {isMobile && (
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 2,
                backgroundColor: 'background.paper',
                display: 'flex',
                alignItems: 'center',
                py: 1,
                mx: -2,
                px: 1,
                borderBottom: '1px solid',
                borderColor: 'divider',
              }}
            >
              <IconButton onClick={onClose} sx={{ color: 'text.primary' }}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Job Details
              </Typography>
            </Box>
          )}

          {/* Desktop: close button */}
          <IconButton
            onClick={onClose}
            sx={{
              display: { xs: 'none', md: 'flex' },
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'grey.500',
              zIndex: 1
            }}
          >
            <CloseIcon />
          </IconButton>

          <JobDetailContent
            job={job}
            rankedJob={rankedJob}
            conversationId={conversationId}
            onFavoriteClick={onFavoriteClick}
            isMobile={isMobile}
          />
        </Box>
      </Slide>
    </Modal>
  )
})

JobModal.displayName = 'JobModal'

export default JobModal
